import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionService extends BaseProvider {
  itemToEdit: any = { Id: null };
  transactionId: any = 'new';
  visibleModule: any = 'main';
  timeline: any = [];
  isReturning = false;
  stopCamera = false;

  searchList: any = [];
  transactionRefresher = new Subject();
  afterTransactionRefresh = new Subject();
  tabChangeRequest = new Subject<number>();
  sentTransactionTypeId: any;
  filter: any = '';
  stats: any;
  counter: any;
  copyAmount = 1;
  proponent: any = {};
  licenseNumber: number | string;
  expirationDate: any;

  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public ls: LsHelperService,
    public authService: AuthService,
    public utilsService: UtilsService
  ) {
    super();

    this.baseUrl = 'userProcess';
  }

  clearTransactionRefresher() {
    this.transactionRefresher.unsubscribe();

    this.transactionRefresher = new Subject<any>();
  }

  getLookups() {
    return new Promise((resolve, reject) => {
      if (this.lookups) {
        resolve(this.lookups);
      }

      this.url = this.globals.dataUrl + this.baseUrl + '/lookup';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.lookups = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getById(id) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.itemToEdit = data.Data;
          if (!this.itemToEdit.CaseNumber && !this.itemToEdit.CadastreNumber) {
            this.itemToEdit.CadastreNumber = this.itemToEdit.TempCaseNumber;
          }

          if (this.itemToEdit.CaseNumber && !this.itemToEdit.CadastreNumber) {
            this.itemToEdit.CadastreNumber = this.itemToEdit.CaseNumber;
          }

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getTimeline(id) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + '/process/' + id + '/timeline';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.timeline = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getTransactionsForUser() {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/page/' +
        this.page +
        '/size/' +
        this.size;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getFilteredTransactionsForUser() {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/page/' +
        this.page +
        '/size/' +
        this.size +
        '/filter/' +
        this.filter;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getStats() {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/stats';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.stats = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getProponentById(userId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + 'userProfile/' + userId;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.proponent = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getCounter(id) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/counter/processId/' +
        id +
        '/copies/' +
        this.copyAmount;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.counter = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactions(params) {
    this.list = [];
    return new Promise((resolve, reject) => {

      let statusId: any;

      statusId = params.statusId;

      if (params.statusId.label) {
        statusId = params.statusId.label;
      }

      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/proponente/search/page/' +
        params.pageNumber +
        '/size/' +
        params.pageSize +
        '?term=' +
        params.term +
        this.utilsService.formatParamUri({
          paramField: statusId,
          paramName: 'status',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateFrom,
          paramName: 'dateFrom',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateTo,
          paramName: 'dateTo',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.processType,
          paramName: 'processType',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.filterByFlagged,
          paramName: 'filterByFlagged',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.sortColumn,
          paramName: 'sortColumn',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.sortDirection,
          paramName: 'sortDirection',
        });

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;
          // this.pageData(data.Data);

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactionsAdvancedSearch(params) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        'capitalCase/search/advanced' +
        '/page/' +
        params.pageNumber +
        '/size/' +
        params.pageSize +
        '?clientName=' +
        params.clientName +
        '&caseNumber=' +
        params.caseNumber +
        '&finca=' +
        params.finca +
        '&loanNumber=' +
        params.loanNumber;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  startTransaction(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl;

      this.http.post(this.url, params).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  startUserProcessCreateWithParent(params) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${this.baseUrl}/userProcessCreateWithParent`;

      this.http.post(this.url, params).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  startUserProcessCreateRenovation(params) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${this.baseUrl}/userProcessCreateRenovation`;

      this.http.post(this.url, params).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  attendTransaction(processId) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + `/process/${processId}/attend`;

      this.http.post(this.url, null).subscribe(
        (data: any) => {

          resolve(data);

        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  submitTransaction(processId) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + `/process/${processId}/submit`;

      this.http.post(this.url, null).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  userCanAttendCase() {
    let canAttend = false;

    if (
      this.itemToEdit.CurrentUserCanAttendCase === 1 &&
      this.itemToEdit.AssignedToCurrentUser !== 1
    ) {
      canAttend = true;
    }

    return canAttend;
  }

  userCanInteract() {
    let canInteract = false;
    const canAttendProcesses = this.authService.hasPolicyBool(
      'CanAttendProcesses'
    );

    if (
      this.itemToEdit.AssignedToCurrentUser === 1 ||
      this.itemToEdit.CreatedByCurrentUser === 1 ||
      canAttendProcesses
    ) {
      canInteract = true;
    }

    return canInteract;
  }

  deleteTransaction(transactionId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/${transactionId}`;

      this.http.delete(this.url).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  userCreatedCase() {
    let createdCase = false;

    if (this.itemToEdit.CreatedByCurrentUser === 1) {
      createdCase = true;
    }

    return createdCase;
  }

  getTransactionsByParams(params: HttpParams) {

    return new Promise((resolve, reject) => {

      this.url = this.globals.dataUrl + 'adminUserTransaction' + '/search';

      this.http.get(this.url, { params }).subscribe(
        (data: any) => {
          this.searchList = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getTransactionsByProfileId(params: HttpParams) {

    return new Promise((resolve, reject) => {

      this.url = this.globals.dataUrl + 'adminUserTransaction' + '/searchByUserProfile';

      this.http.get(this.url, { params }).subscribe(
        (data: any) => {
          this.searchList = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }



  UserProcessProfileUpdate(profileId, processTypeIds) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${'adminUserTransaction'}/userProcessId/profileId/${profileId}`;

      this.http.post(this.url, { processTypeIds: processTypeIds, profileId: profileId }).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err: any) => {
          reject(err);
        }
      );
    });
  }

  OtherUserProcessProfileUpdate(profileId, otherUserId, processTypeIds) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${'adminUserTransaction'}/otherUser/${otherUserId}/userProcessId/profileId/${profileId}`;

      this.http.post(this.url, { processTypeIds: processTypeIds, profileId: profileId, otherUserId: otherUserId }).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err: any) => {
          reject(err);
        }
      );
    });
  }

  delete(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + 'adminUserTransaction' + '/' + params.id;

      this.http.delete(this.url).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactionsByProfile(params) {
    this.list = [];
    return new Promise((resolve, reject) => {

      let statusId: any;

      statusId = params.statusId;

      if (params.statusId.label) {
        statusId = params.statusId.label;
      }

      const selectedProfile = JSON.parse(localStorage.getItem('selectedProfile'));
      if (selectedProfile) {
        this.url =
          `${this.globals.dataUrl}${this.baseUrl}ByProfile/${selectedProfile.Id}/search?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}` +
          this.utilsService.formatParamUri({
            paramField: params.term === 'null' ? '' : params.term,
            paramName: 'term',
          }) +
          this.utilsService.formatParamUri({
            paramField: statusId,
            paramName: 'status',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.dateFrom,
            paramName: 'dateFrom',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.dateTo,
            paramName: 'dateTo',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.processType,
            paramName: 'processType',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.filterByFlagged,
            paramName: 'filterByFlagged',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.sortColumn,
            paramName: 'sortColumn',
          }) +
          this.utilsService.formatParamUri({
            paramField: params.sortDirection,
            paramName: 'sortDirection',
          });
      } else {
        this.list = [];
        resolve([]);
        return;
      }

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;
          // this.pageData(data.Data);

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactionsExternal(params) {
    this.list = [];
    return new Promise((resolve, reject) => {

      let statusId: any;

      statusId = params.statusId;

      if (params.statusId.label) {
        statusId = params.statusId.label;
      }

      this.url =
        `${this.globals.dataUrl}${this.baseUrl}SearchExternal/search?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}` +
        this.utilsService.formatParamUri({
          paramField: params.term === 'null' ? '' : params.term,
          paramName: 'term',
        }) +
        this.utilsService.formatParamUri({
          paramField: statusId,
          paramName: 'status',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateFrom,
          paramName: 'dateFrom',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateTo,
          paramName: 'dateTo',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.processType,
          paramName: 'processType',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.filterByFlagged,
          paramName: 'filterByFlagged',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.sortColumn,
          paramName: 'sortColumn',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.sortDirection,
          paramName: 'sortDirection',
        });

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;
          // this.pageData(data.Data);

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
}
